import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import InternalChat from "../pages/InternalChat";
import Tags from "../pages/Tags";
import Profiles from "../pages/Profiles";
import ScheduledBroadcasts from "../pages/ScheduledBroadcasts";
import TicketAudits from "../pages/TicketAudits";

import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate permission={["page:dashboard", "dashboard:list"]} />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate permission={["page:tickets", "tickets:list"]} />
                <Route exact path="/ticket-audits" component={TicketAudits} isPrivate permission={["page:ticket-audits", "ticket-audits:list"]} />
                <Route exact path="/internal-chat" component={InternalChat} isPrivate permission={["page:internal-chat", "internal-chat:list"]} />
                <Route exact path="/tags" component={Tags} isPrivate permission={["page:tags", "tags:list"]} />
                <Route exact path="/connections" component={Connections} isPrivate permission={["page:connections", "connections:list"]} />
                <Route exact path="/contacts" component={Contacts} isPrivate permission={["page:contacts", "contacts:list"]} />
                <Route
                  exact
                  path="/scheduled-broadcasts"
                  component={ScheduledBroadcasts}
                  isPrivate
                  permission={["page:scheduled-broadcasts", "scheduled-broadcasts:list"]}
                />
                <Route exact path="/users" component={Users} isPrivate permission={["page:users", "users:list"]} />
                <Route exact path="/profiles" component={Profiles} isPrivate permission={["page:profiles", "profiles:list"]} />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate permission={["page:quickAnswers", "quickAnswers:list"]} />
                <Route exact path="/Settings" component={Settings} isPrivate permission={["page:settings", "settings:list"]} />
                <Route exact path="/Queues" component={Queues} isPrivate permission={["page:queues", "queues:list"]} />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
